import {
  fontSizeVars,
  fontWeightVars,
  lineHeightVars,
  spacingVars,
} from '@tundr/ds-foundations';
import { style } from '@vanilla-extract/css';

export const pageSizeSelectorClass = style({
  flexBasis: 'auto',
  display: 'flex',
  alignItems: 'center',
  gap: spacingVars.sm,
  fontSize: fontSizeVars.body.body1,
});

export const pageSizeSelectorLabelClass = style({
  fontSize: fontSizeVars.body.body1,
  fontWeight: fontWeightVars.bold,
  lineHeight: lineHeightVars.body.body1,
});

const PAGE_SIZE_SELECTOR_WIDTH = '100px';

export const pageSizeSelectorTriggerClass = style({
  width: PAGE_SIZE_SELECTOR_WIDTH,
  minWidth: PAGE_SIZE_SELECTOR_WIDTH,
  cursor: 'pointer',
  pointerEvents: 'none',
});
